import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";

const router = createBrowserRouter(
  [
    {
      path: "/*",
      element: <App />,
    },
  ],
  {
    basename: "/minha-casa-mais-bonita",
  }
);

createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />
);